import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './ContractsPanel.module.scss';
import 'src/css/themes.scss';
import { IconDropDown, IconDropDownReverse } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Link } from '@framework-controls/core';
import { strings } from 'src/localization';
import { random } from 'lodash';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    index: number;
    type: string;
}

const ContractsPanel = (props: IProps) => {
    const [contractOpen, setContractOpen] = useState(true);
    const toggleContract = useCallback(() => {
        setContractOpen(!contractOpen);
    }, [contractOpen]);

    let contractArea: ReactElement | null = null;
    switch (props.type) {
        case 'mc':
        default: {
            let mcTitle = props.connectedVehicle.mc[props.index].desc;
            if (props.connectedVehicle.mc[props.index].num) {
                mcTitle = props.connectedVehicle.mc[props.index].desc + ' (' + strings.AccountNum +
                ': ' + props.connectedVehicle.mc[props.index].num + ')';
            }

            let mcEnrollDate: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].enrollDate) {
                mcEnrollDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.EnrollmentDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].enrollDate}</div>
                    </span>;
            }

            let mcEffectiveDate: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].effDate) {
                mcEffectiveDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.EffectiveDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].effDate}</div>
                    </span>;
            }

            let mcExpirationDate: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].expDate) {
                mcExpirationDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ExpirationDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].expDate}</div>
                    </span>;
            }

            let mcStartDate: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].startDate) {
                mcStartDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.StartDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].startDate}</div>
                    </span>;
            }

            let mcType: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].type) {
                mcType =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractType}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].type}</div>
                    </span>;
            }

            let mcCode: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].code) {
                mcCode =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractCode}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].code}</div>
                    </span>;
            }

            let mcMiles: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].miles) {
                mcMiles =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.CVMileage}</div>
                        <div className={css.dataValue}>{strings.UpTo + ' ' +
                            props.connectedVehicle.mc[props.index].miles + ' ' + strings.CVMiles}</div>
                    </span>;
            }

            let mcDeductible: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].deduct) {
                mcDeductible =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Deductible}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].deduct}</div>
                    </span>;
            }

            let mcVendor: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].vendor) {
                mcVendor =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Vendor}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].vendor}</div>
                    </span>;
            }

            let mcSellerDlrNo: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].sellerDlrNo) {
                mcSellerDlrNo = <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].sellerDlrNo}</div>;
            }

            let mcSoldByName: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].soldBy) {
                mcSoldByName = <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].soldBy}</div>;
            }

            let mcSoldBy: ReactElement | null = null;
            if (mcSellerDlrNo || mcSoldByName) {
                mcSoldBy =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.SoldBy}</div>
                        {mcSoldByName}
                        {mcSellerDlrNo}
                    </span>;
            }

            let mcSoldTo: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].soldTo) {
                mcSoldTo =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.SoldTo}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].soldTo}</div>
                    </span>;
            }

            let mcCoverageMonths: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].coverageMonths) {
                mcCoverageMonths =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.MonthsCovered}</div>
                        <div className={css.dataValue}>{strings.UpTo + ' ' +
                            props.connectedVehicle.mc[props.index].coverageMonths + ' ' + strings.Months}</div>
                    </span>;
            }

            let mcContractCategory: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].contractCatgry) {
                mcContractCategory =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractCategory}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].contractCatgry}</div>
                    </span>;
            }

            let mcFormNum: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].formNum) {
                mcFormNum =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Form}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].formNum}</div>
                    </span>;
            }

            let mcFormMonth: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].formMonth) {
                mcFormMonth =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.FormMonth}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].formMonth}</div>
                    </span>;
            }

            let mcFormYear: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].formYear) {
                mcFormYear =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.FormYear}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.mc[props.index].formYear}</div>
                    </span>;
            }

            let mcContractDetails: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].url) {
                mcContractDetails =
                    <span className={css.dataBlock}>
                        <div className={css.urlLit}>{strings.ContractDetails}</div>
                        <Link
                            id='mcLink'
                            url={props.connectedVehicle.mc[props.index].url}
                            className={css.urlValue}
                        >
                            <div>{strings.ViewContractDetails}</div>
                        </Link>
                    </span>;
            }

            let mcContractDetailsList: ReactElement[] | null = null;
            if (props.connectedVehicle.mc[props.index].svc.length > 0) {
                mcContractDetailsList = props.connectedVehicle.mc[props.index].svc.map(svc => <span
                    id={svc.ordNotes}
                    key={random(99999)}>
                    <span className={css.contractDetail}>
                        <div className={css.detailDesc}>{svc.ordNotes ? svc.ordNotes : svc.desc}</div>
                        <div className={css.detailStatus}>{svc.stat ? '(' + svc.stat + ')' : null}</div>
                    </span>
                </span>);
            }

            let mcContractDetailsArea: ReactElement | null = null;
            if (props.connectedVehicle.mc[props.index].svc.length > 0) {
                mcContractDetailsArea =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractDetails}</div>
                        {mcContractDetailsList}
                    </span>;
            }

            let mcBlock: ReactElement | null = null;
            if (contractOpen) {
                mcBlock =
                    <div>
                        <div className={css.dataRow}>
                            {mcEnrollDate}
                            {mcEffectiveDate}
                            {mcExpirationDate}
                            {mcStartDate}
                            {mcType}
                            {mcCode}
                            {mcMiles}
                            {mcDeductible}
                            {mcVendor}
                            {mcSoldBy}
                            {mcSoldTo}
                            {mcCoverageMonths}
                            {mcContractCategory}
                            {mcFormNum}
                            {mcFormMonth}
                            {mcFormYear}
                        </div>
                        {mcContractDetails}
                        {mcContractDetailsArea}
                    </div>;
            }

            let mcIcon: ReactElement | null = null;
            if (contractOpen) {
                mcIcon = <IconDropDownReverse className={css.icon} onClick={() => toggleContract()} />;
            } else {
                mcIcon = <IconDropDown className={css.icon} onClick={() => toggleContract()} />;
            }

            contractArea =
                <div>
                    <span
                        id={'mcRow'} className={css.mcRow} onClick={() => toggleContract()}>
                        <div className={css.desc}>{mcTitle}</div>
                        <div className={css.status}>{props.connectedVehicle.mc[props.index].status}</div>
                        {mcIcon}
                    </span>
                    {mcBlock}
                </div>;
            break;
        }
        case 'xc': {
            let xcTitle = props.connectedVehicle.xc[props.index].desc;
            if (props.connectedVehicle.xc[props.index].num) {
                xcTitle = props.connectedVehicle.xc[props.index].desc + ' (' + strings.AccountNum +
                ': ' + props.connectedVehicle.xc[props.index].num + ')';
            }

            let xcEnrollDate: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].enrollDate) {
                xcEnrollDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.EnrollmentDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].enrollDate}</div>
                    </span>;
            }

            let xcEffectiveDate: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].effDate) {
                xcEffectiveDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.EffectiveDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].effDate}</div>
                    </span>;
            }

            let xcExpirationDate: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].expDate) {
                xcExpirationDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ExpirationDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].expDate}</div>
                    </span>;
            }

            let xcStartDate: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].startDate) {
                xcStartDate =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.StartDate}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].startDate}</div>
                    </span>;
            }

            let xcType: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].type) {
                xcType =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractType}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].type}</div>
                    </span>;
            }

            let xcCode: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].code) {
                xcCode =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractCode}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].code}</div>
                    </span>;
            }

            let xcMiles: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].miles) {
                xcMiles =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.CVMileage}</div>
                        <div className={css.dataValue}>{strings.UpTo + ' ' +
                            props.connectedVehicle.xc[props.index].miles + ' ' + strings.CVMiles}</div>
                    </span>;
            }

            let xcDeductible: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].deduct) {
                xcDeductible =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Deductible}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].deduct}</div>
                    </span>;
            }

            let xcVendor: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].vendor) {
                xcVendor =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Vendor}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].vendor}</div>
                    </span>;
            }

            let xcSellerDlrNo: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].sellerDlrNo) {
                xcSellerDlrNo = <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].sellerDlrNo}</div>;
            }

            let xcSoldBy: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].soldBy) {
                xcSoldBy =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.SoldBy}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].soldBy}</div>
                        {xcSellerDlrNo}
                    </span>;
            }

            let xcSoldTo: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].soldTo) {
                xcSoldTo =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.SoldTo}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].soldTo}</div>
                    </span>;
            }

            let xcCoverageMonths: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].coverageMonths) {
                xcCoverageMonths =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.MonthsCovered}</div>
                        <div className={css.dataValue}>{strings.UpTo + ' ' +
                            props.connectedVehicle.xc[props.index].coverageMonths + ' ' + strings.Months}</div>
                    </span>;
            }

            let xcContractCategory: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].contractCatgry) {
                xcContractCategory =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractCategory}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].contractCatgry}</div>
                    </span>;
            }

            let xcFormNum: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].formNum) {
                xcFormNum =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Form}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].formNum}</div>
                    </span>;
            }

            let xcFormMonth: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].formMonth) {
                xcFormMonth =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.FormMonth}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].formMonth}</div>
                    </span>;
            }

            let xcFormYear: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].formYear) {
                xcFormYear =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.FormYear}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.xc[props.index].formYear}</div>
                    </span>;
            }

            let xcContractDetails: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].url) {
                xcContractDetails =
                    <span className={css.dataBlock}>
                        <div className={css.urlLit}>{strings.ContractDetails}</div>
                        <Link
                            id='mcLink'
                            url={props.connectedVehicle.xc[props.index].url}
                            className={css.urlValue}
                        >
                            <div>{strings.ViewContractDetails}</div>
                        </Link>
                    </span>;
            }

            let xcContractDetailsList: ReactElement[] | null = null;
            if (props.connectedVehicle.xc[props.index].svc.length > 0) {
                xcContractDetailsList = props.connectedVehicle.xc[props.index].svc.map(svc => <span
                    id={svc.ordNotes}
                    key={random(99999)}>
                    <span className={css.contractDetail}>
                        <div className={css.detailDesc}>{svc.ordNotes ? svc.ordNotes : svc.desc}</div>
                        <div className={css.detailStatus}>{svc.stat ? '(' + svc.stat + ')' : null}</div>
                    </span>
                </span>);
            }

            let xcContractDetailsArea: ReactElement | null = null;
            if (props.connectedVehicle.xc[props.index].svc.length > 0) {
                xcContractDetailsArea =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractDetails}</div>
                        {xcContractDetailsList}
                    </span>;
            }

            let xcBlock: ReactElement | null = null;
            if (contractOpen) {
                xcBlock =
                    <div>
                        <div className={css.dataRow}>
                            {xcEnrollDate}
                            {xcEffectiveDate}
                            {xcExpirationDate}
                            {xcStartDate}
                            {xcType}
                            {xcCode}
                            {xcMiles}
                            {xcDeductible}
                            {xcVendor}
                            {xcSoldBy}
                            {xcSoldTo}
                            {xcCoverageMonths}
                            {xcContractCategory}
                            {xcFormNum}
                            {xcFormMonth}
                            {xcFormYear}
                        </div>
                        {xcContractDetails}
                        {xcContractDetailsArea}
                    </div>;
            }

            let xcIcon: ReactElement | null = null;
            if (contractOpen) {
                xcIcon = <IconDropDownReverse className={css.icon} onClick={() => toggleContract()} />;
            } else {
                xcIcon = <IconDropDown className={css.icon} onClick={() => toggleContract()} />;
            }

            contractArea =
                <div>
                    <span
                        id={'xcRow'} className={css.xcRow} onClick={() => toggleContract()}>
                        <div className={css.desc}>{xcTitle}</div>
                        <div className={css.status}>{props.connectedVehicle.xc[props.index].status}</div>
                        <div className={css.icon}>
                            {xcIcon}
                        </div>
                    </span>
                    {xcBlock}
                </div>;
            break;
        }
        case 'ac': {
            const acTitle = props.connectedVehicle.ac[props.index].desc;

            let acMsrp: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].msrp) {
                acMsrp =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.MSRP}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].msrp}</div>
                    </span>;
            }

            let acWholesale: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].wholesale) {
                acWholesale =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Wholesale}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].wholesale}</div>
                    </span>;
            }

            let acExpirationMonths: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].expMonths) {
                acExpirationMonths =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ExpirationMonths}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].expMonths}</div>
                    </span>;
            }

            let acType: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].type) {
                acType =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractType}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].type}</div>
                    </span>;
            }

            let acCode: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].code) {
                acCode =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.ContractCode}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].code}</div>
                    </span>;
            }

            let acMiles: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].miles) {
                acMiles =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.CVMileage}</div>
                        <div className={css.dataValue}>{strings.UpTo + ' ' +
                            props.connectedVehicle.ac[props.index].miles + ' ' + strings.CVMiles}</div>
                    </span>;
            }

            let acDeductible: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].deduct) {
                acDeductible =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Deductible}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].deduct}</div>
                    </span>;
            }

            let acVendor: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].vendor) {
                acVendor =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Vendor}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].vendor}</div>
                    </span>;
            }

            let acMessage: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].message) {
                acMessage =
                    <span className={css.dataBlock}>
                        <div className={css.dataLit}>{strings.Message}</div>
                        <div className={css.dataValue}>{props.connectedVehicle.ac[props.index].message}</div>
                    </span>;
            }

            let acUrls: ReactElement | null = null;
            if (props.connectedVehicle.ac[props.index].dcsUrl || props.connectedVehicle.ac[props.index].infonetUrl) {
                let acUrl: ReactElement | null = null;
                let dcsUrl: ReactElement | null = null;
                let infonetUrl: ReactElement | null = null;
                if (props.connectedVehicle.ac[props.index].dcsUrl) {
                    dcsUrl =
                        <Link
                            id='dcsLink'
                            url={props.connectedVehicle.ac[props.index].dcsUrl}
                            className={css.urlValue}
                        >
                            <div>{strings.ViewContractDetails}</div>
                        </Link>;
                }
                if (props.connectedVehicle.ac[props.index].infonetUrl) {
                    infonetUrl =
                        <Link
                            id='infonetLink'
                            url={props.connectedVehicle.ac[props.index].infonetUrl}
                            className={css.urlValue}
                        >
                            <div>{strings.Infonet}</div>
                        </Link>;
                }
                acUrl = <div>{dcsUrl}</div>;
                if (!dcsUrl) {
                    acUrl = <div>{infonetUrl}</div>;
                }
                if (dcsUrl && infonetUrl) {
                    acUrl =
                        <span className={css.urls}>
                            {dcsUrl}
                            <p className={css.urlSlash}>/</p>
                            {infonetUrl}
                        </span>;
                }
                acUrls =
                    <span className={css.dataBlock}>
                        <div className={css.urlLit}>{strings.ContractDetails}</div>
                        {acUrl}
                    </span>;
            }

            let acBlock: ReactElement | null = null;
            if (contractOpen) {
                acBlock =
                <div>
                    <div className={css.dataRow}>
                        {acMsrp}
                        {acWholesale}
                        {acExpirationMonths}
                        {acType}
                        {acCode}
                        {acMiles}
                        {acDeductible}
                        {acVendor}
                        {acMessage}
                    </div>
                    {acUrls}
                </div>;
            }

            let acIcon: ReactElement | null = null;
            if (contractOpen) {
                acIcon = <IconDropDownReverse className={css.icon} onClick={() => toggleContract()} />;
            } else {
                acIcon = <IconDropDown className={css.icon} onClick={() => toggleContract()} />;
            }

            contractArea =
                <div>
                    <span
                        id={'acRow'} className={css.acRow} onClick={() => toggleContract()}>
                        <div className={css.desc}>{acTitle}</div>
                        <div className={css.status}>{strings.Available}</div>
                        <div className={css.icon}>
                            {acIcon}
                        </div>
                    </span>
                    {acBlock}
                </div>;
            break;
        }
    }

    return (
        <div>
            <div className={css.contract}>
                {contractArea}
            </div>
        </div>
    );
};

export default ContractsPanel;